import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _defineProperty from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "vant/es/image-preview/style";
import _ImagePreview from "vant/es/image-preview";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/esnext.typed-array.to-reversed.js";
import "core-js/modules/esnext.typed-array.to-sorted.js";
import "core-js/modules/esnext.typed-array.with.js";
import "core-js/modules/es.array.map.js";
var topicParams = {
  'filter[hot]': 1,
  'filter[content]': ''
};
import { topicList, topicCreate, uploadImg, post } from '@/api/mg';
import imageCompression from 'browser-image-compression';
import $ from 'jquery';
import Compressor from 'compressorjs';
import Video from 'views/social/search/video.vue';
export default {
  components: _defineProperty({
    Video: Video
  }, _ImagePreview.Component.name, _ImagePreview.Component),
  data: function data() {
    return {
      type: '1',
      title: '',
      value1: '1',
      isGetResault: false,
      isEmpty: true,
      value: '',
      isInput: false,
      isShowPop: false,
      message: '',
      searchTopicList: [],
      hotTopicList: [],
      selectTopicList: [],
      imgArr: [],
      fileList: [],
      pid: '',
      highLight: false,
      isCurrent: true,
      sUrl: '',
      isClose: false,
      priviewList: [],
      imageUrl: '',
      limited: true,
      isAndorid: navigator.userAgent.includes('Android'),
      showSheet: false,
      actionsPicture: [{
        id: 1,
        name: this.$t('Camera')
      }, {
        id: 2,
        name: this.$t('Picture')
      }],
      actionsVideos: [{
        id: 2,
        name: this.$t('Video')
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    window.fileSelected = this.fileSelected;
    window['fileSelected'] = function (data) {
      _this.fileSelected(data);
    };
    this.$nextTick(function () {
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        console.log('123451');
        if (window.Android) {
          var devicePixelRatio = window.devicePixelRatio;
          console.log(devicePixelRatio);
          console.log(window.Android.getStatusBarHeight());
          var pxSize = Number(window.Android.getStatusBarHeight() / devicePixelRatio);
          console.log('pxsize', pxSize);
          $('.titleBar').css('padding-top', pxSize);
        }
      }
    });
  },
  created: function created() {
    this.value = '';
    this.pid = localStorage.getItem('pid');
    topicParams['filter[content]'] = '';
    topicParams['perPage'] = 10;
    topicParams['page'] = 1;
    this.getTopicList(topicParams);
    this.sUrl = this.$route.query.url;
    console.log(navigator.userAgent);
    var device_type = navigator.userAgent;
    // let device_type  = 'Mozilla/5.0 (Linux; Android 13; SM-A5160 Build/TP1A.220624.014; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/112.0.5615.101 Mobile Safari/537.36 AgentWeb/5.0.0  UCBrowser/11.6.4.950'
    if (device_type.includes('Android')) {
      console.log('安卓手机');
      var m1 = device_type.match(/Android.*?(?=;)/);
      if (m1 && m1.length > 0) {
        var system = m1[0]; // Android 9
        console.log('system', system);
        if (system == 'Android 13') {
          this.limited = false;
        }
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if ($('.van-image-preview').css('display') == 'none' && $('.van-image-preview__overlay').css('display') == 'none' || $('.van-image-preview').css('display') == undefined && $('.van-image-preview__overlay').css('display') == undefined) {
      next(true);
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    } else {
      next(false);
    }
  },
  methods: {
    openActionSheet: function openActionSheet() {
      console.log('abcd');
      this.showSheet = true;
    },
    onSelectPicture: function onSelectPicture(item) {
      if (item.id == 1) {
        // 打开相机
        this.beforeReadFile(1);
        this.showSheet = false;
      } else if (item.id == 2) {
        // 打开相册
        this.beforeReadFile(2);
        console.log('langage', localStorage.getItem('language'));
        this.showSheet = false;
      }
    },
    beforeReadFile: function beforeReadFile(pic_type) {
      if (pic_type == 1) {
        // 选择相机
        if (this.isAndorid) {
          // 安卓手机
          if (window.Android) {
            window.Android.openNativeCamera();
          }
        }
      } else if (pic_type == 2) {
        // 选择图片
        if (this.isAndorid) {
          // 安卓手机
          if (window.Android) {
            if (this.type == 2) {
              window.Android.openNativeAlbum(800002);
            } else {
              window.Android.openNativeAlbum(800001);
            }
          }
        }
      }
    },
    handleDelImg: function handleDelImg(index) {
      this.fileList.splice(index, 1);
    },
    preview: function preview(e, index) {
      var _this2 = this;
      this.priviewList = [];
      this.fileList.forEach(function (item, index) {
        _this2.priviewList.push(item.content);
      });
      _ImagePreview({
        images: this.priviewList,
        startPosition: index.index,
        onClose: function onClose() {},
        closeOnPopstate: true
      });
    },
    close: function close(topicId) {
      var _this3 = this;
      this.selectTopicList.forEach(function (item, index) {
        if (Object.values(item)[0] === topicId) {
          _this3.selectTopicList.splice(index, 1);
        }
      });
    },
    fileChange: function fileChange() {
      console.log(this.type);
      this.fileList = [];
    },
    cateoryChange: function cateoryChange(val) {
      this.title = '';
      this.selectTopicList = [];
    },
    onOversize: function onOversize() {
      console.log(this.fileList, 'this.fileList');
      _Toast(this.$t('oversizeVideo'));
    },
    onOversizeP: function onOversizeP() {
      // Toast(this.$t('oversizePicture'))
      console.log(this.fileList, 'this.fileList');
      _Toast(this.$t('oversizePicture'));
    },
    del: function del(file) {
      if (this.fileList.length == 0 && !this.message.trim()) {
        this.highLight = false;
      } else if (this.message.trim()) {
        this.highLight = true;
      }
      console.log(this.fileList, 'this.fileList');
    },
    getBase64: function getBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        var imgResult = '';
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    afterReadImg: function afterReadImg(imageFile) {
      var _this4 = this;
      var options = {
        maxSizeMB: 6,
        maxWidthOrHeight: 1920,
        useWebWorker: true
      };
      if (imageFile instanceof Array) {
        imageFile.forEach(function (item) {
          imageCompression(item, options).then(function (compressedFile) {
            var img = new window.File([compressedFile], compressedFile.name);
            _this4.getBase64(item).then(function (res) {
              _this4.afterRead({
                content: res,
                file: img
              });
            });
          }).catch(function (error) {
            console.log(error.message);
          });
        });
      } else {
        imageCompression(imageFile, options).then(function (compressedFile) {
          var img = new window.File([compressedFile], compressedFile.name);
          _this4.getBase64(imageFile).then(function (res) {
            _this4.afterRead({
              content: res,
              file: img,
              type: 'img'
            });
          });
        }).catch(function (error) {
          console.log(error.message);
        });
      }
    },
    isMp4Base64: function isMp4Base64(base64) {
      // 使用正则表达式检查格式
      var regex = /^data:video\/mp4;base64,/;
      if (!regex.test(base64)) {
        return false;
      }
      return true;
    },
    fileSelected: function fileSelected(uri) {
      var _this5 = this;
      var mp4 = this.isMp4Base64(uri);
      var mime = '';
      var type = '';
      if (!mp4) {
        type = this.base64FileHeaderMapper(uri);
        console.log(type);
        if (type == 'jpeg' || type == 'jpg') {
          mime = 'image/jpeg';
        } else {
          if (localStorage.getItem('language') == 'th') {
            _Toast('รองรับไฟล์ (.JPG) เท่านั้น');
          } else {
            _Toast('Only  JPG files are supported');
          }
          return;
        }
      } else {
        mime = 'video/mp4';
        type = 'mp4';
      }
      var name = new Date().getTime() + '.' + type;
      if (mime == 'video/mp4') {
        uri = uri.split(',')[1];
      }
      var file = this.blobToFile(uri, name, mime);
      console.log('文件', file);
      var formData = new FormData();
      formData.append('file', file);
      formData.append('type', this.type);
      formData.append('fileName', name);
      if (this.type == 2) {
        var num = 1024.00;
        var size = (file.size / Math.pow(num, 2)).toFixed(2);
        if (Number(size) > 20) {
          file.status = 'failed';
          file.message = this.$t('failed');
          _Toast(this.$t('limitVideo'));
          return;
        }
      }
      _Toast.loading({
        message: localStorage.getItem('language') === 'th' ? 'กำลังโหลด...' : 'Loading...',
        forbidClick: true,
        duration: 0
      });
      uploadImg(formData).then(function (res) {
        if (res.Code === 0) {
          var _res$Data$thumbUrl;
          _this5.fileList.push({
            id: res.Data.id,
            url: (_res$Data$thumbUrl = res.Data.thumbUrl) !== null && _res$Data$thumbUrl !== void 0 ? _res$Data$thumbUrl : res.Data.url,
            name: res.Data.fileName,
            type: res.Data.type,
            status: 'done'
          });
          console.log('fileList', _this5.fileList);
          _Toast.clear();
        } else {
          _Toast(_this5.$t('TimeOut'));
          _Toast.clear();
        }
      }).catch(function () {
        _Toast(_this5.$t('failed'));
      });
    },
    base64FileHeaderMapper: function base64FileHeaderMapper(fileBase64) {
      var fileHeader = new Map();
      // 获取不同文件的文件头前3个字作为判断依据
      fileHeader.set('/9j', 'jpeg');
      fileHeader.set('iVB', 'png');
      fileHeader.set('data:video/mp4', 'mp4');
      var res = '';
      // 遍历map中所提及的文件头特征
      fileHeader.forEach(function (v, k) {
        // 箭头函数IE不支持 兼容IE需改写
        if (k == fileBase64.substr(0, 3)) {
          res = v;
        }
      });
      // 如果不在map中返回unknown file
      if (res == '') {
        res = 'unknown file';
      }
      // 否则返回map中的value值
      return res;
    },
    blobToFile: function blobToFile(base64, fileName, type) {
      var bstr = atob(base64);
      var n = bstr.length;
      var mime = '';
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      if (type == 'jpeg' || type == 'jpg') {
        mime = 'image/jpeg';
      } else if (type == 'png') {
        mime = 'image/png';
      }
      return new File([u8arr], fileName, {
        type: mime
      });
    },
    afterRead: function afterRead(file) {
      var _this6 = this;
      // 此时可以自行将文件上传至服务器
      if (file instanceof Array) {
        // 判断是否是数组
        file.map(function (item) {
          var formData = new FormData();
          formData.append('file', item.file);
          formData.append('type', _this6.type);
          item.status = 'uploading';
          item.message = _this6.$t('uploading');
          uploadImg(formData).then(function (res) {
            if (res.Code === 0) {
              item.id = res.Data.id;
              item.status = 'done';
              item.message = _this6.$t('Success');
            } else {
              item.status = 'failed';
              item.message = _this6.$t('failed');
              console.log('failed', item);
            }
          }).catch(function () {
            item.status = 'failed';
            item.message = _this6.$t('failed');
            console.log('failed', item);
          });
        });
      } else {
        var formData = new FormData();
        formData.append('file', file.file);
        formData.append('type', this.type);
        if (this.type == 2) {
          var num = 1024.00;
          var size = (file.file.size / Math.pow(num, 2)).toFixed(2);
          if (Number(size) > 20) {
            file.status = 'failed';
            file.message = this.$t('failed');
            _Toast(this.$t('limitVideo'));
            return;
          }
        }
        // this.priviewList.push(file.file.content)
        file.status = 'uploading';
        this.highLight = false;
        file.message = this.$t('uploading');
        uploadImg(formData).then(function (res) {
          if (res.Code === 0) {
            file.id = res.Data.id;
            _this6.highLight = true;
            file.status = 'done';
            file.message = _this6.$t('Success');
          } else {
            file.status = 'failed';
            file.message = _this6.$t('failed');
            console.log('failed', item);
          }
        }).catch(function () {
          file.status = 'failed';
          file.message = _this6.$t('failed');
          console.log('failed', item);
        });
      }
    },
    // 截取视频某帧
    getVideoBase64: function getVideoBase64(url) {
      var that = this;
      return new Promise(function (resolve, reject) {
        var dataURL = '';
        var ua = navigator.userAgent.toLowerCase();
        //  ios 存在video标签不显示同时ios手机端视频上传的格式是.mov格式的文件，故ios视频上传的视频采用默认视频封面提的处理方式，
        var isIos = !ua.match(/Android/i);
        if (url.includes('.mov') || isIos) {
          var imgUrl = 'https://file.baojunev.com/group1/default/20210601/19/05/6/poster_video.jpg';
          resolve(imgUrl);
        } else {
          var video = document.createElement('video');
          video.setAttribute('crossOrigin', 'anonymous'); // 处理跨域
          video.setAttribute('src', url);
          video.setAttribute('width', 304);
          video.setAttribute('height', 180);
          video.currentTime = 0.5;
          video.addEventListener('loadeddata', function () {
            var canvas = document.createElement('canvas');
            var width = video.width; // canvas的尺寸和图片一样
            var height = video.height;
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(video, 0, 0, width, height); // 绘制canvas
            dataURL = canvas.toDataURL('image/png'); // 转换为base64
            var file = that.dataURLtoFile(dataURL, 'file');
            console.log(file, 'file');
            var suffix = ".".concat(file.type.split('/')[1]);
            var size_list = file.size;
            var formData = new FormData();
            formData.append('file', file);
            axios({
              url: "/upload?simple_name=1&suffix=".concat(suffix, "&size_list=") + size_list,
              method: 'post',
              data: formData,
              cache: false,
              contentType: false,
              processData: false,
              dataType: 'json',
              timeout: 20000,
              withCredentials: false
            }).then(function (data) {
              resolve(data.TFS_FILE_NAME[0]);
            });
          });
        }
      });
    },
    // base64 转成文件流
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      // 方式1：
      // let newBlob = new Blob([u8arr],"file", {
      //         type: mime
      //     });
      //     newBlob.lastModifiedDate = new Date();
      //     newBlob.name = Date.now() + '.png';
      //     return newBlob
      return new File([u8arr], Date.now() + '.png', {
        type: mime
      });
    },
    getTopicList: function getTopicList(params, type) {
      var _this7 = this;
      topicList(params).then(function (res) {
        if (res.Code === 0) {
          if (type === 'search') {
            _this7.searchTopicList = res.Data.pageData;
            if (_this7.searchTopicList.length === 0) {
              _this7.isGetResault = true;
            } else {
              _this7.isGetResault = false;
            }
            return;
          }
          _this7.hotTopicList = res.Data.pageData;
        } else {
          _Toast(res.Message);
        }
      });
    },
    getTopic: function getTopic(topicId, topic) {
      var obj = {
        topicId: topicId,
        topic: topic
      };
      var flag = true;
      this.selectTopicList.forEach(function (item) {
        console.log(Object.values(item));
        if (Object.values(item)[0] === topicId) {
          flag = false;
        }
      });
      if (flag) {
        this.selectTopicList.push(obj);
      } else {
        _Toast(this.$t('tae'));
        return;
      }
      this.value = '';
      this.isInput = false;
      this.isShowPop = false;
      this.isEmpty = true;
      this.value = '';
      this.isInput = false;
    },
    createTopic: function createTopic() {
      var _this8 = this;
      var params = {
        topic_name: this.value
      };
      topicCreate(params).then(function (res) {
        if (res.Code === 0) {
          var data = res.Data;
          var obj = {
            topicId: data.topic_id,
            topic: data.content
          };
          _this8.selectTopicList.push(obj);
        } else {
          _Toast(res.Message);
        }
      });
      this.isShowPop = false;
      this.isEmpty = true;
      this.value = '';
      this.isInput = false;
    },
    // getResult(value) {
    // },
    clear: function clear() {
      this.value = '';
      this.isInput = false;
      this.isResults = false;
      this.isEmpty = true;
    },
    fieleInput: function fieleInput() {
      var count = 0;
      if (this.fileList.length !== 0) {
        for (var i = 0; i < this.fileList.length; i++) {
          console.log(this.fileList[i].status);
          if (this.fileList[i].status == 'done') {
            count++;
          }
        }
      }
      if (this.fileList.length !== 0) {
        if (count == this.fileList.length) {
          this.highLight = true;
        } else {
          this.highLight = false;
        }
      } else if (this.message.trim()) {
        this.highLight = true;
      } else {
        this.highLight = false;
      }
    },
    input: function input() {
      if (this.value.trim()) {
        this.isGetResault = false;
        this.isInput = true;
        this.isEmpty = false;
        topicParams['filter[content]'] = this.value;
        topicParams['perPage'] = '';
        topicParams['page'] = '';
        this.getTopicList(topicParams, 'search');
      } else {
        this.isInput = false;
        this.isEmpty = true;
      }
    },
    closePop: function closePop() {
      this.isShowPop = false;
      this.value = '';
      this.isInput = false;
      this.isEmpty = true;
    },
    topicSearch: function topicSearch() {
      this.isShowPop = true;
    },
    publish: function publish() {
      var _this9 = this;
      for (var i = 0; i < this.fileList.length; i++) {
        console.log(this.fileList[i].status);
        if (this.fileList[i].status !== 'done') {
          return;
        }
      }
      if (this.pid === '1' && this.value1 === '4') {
        console.log(this.fileList, this.message, 'this.fileList,this.message');
        if (this.title.trim() === '') {
          // Toast($t('incompleteInformation'))
          return;
        } else if (this.fileList.length === 0 && this.message.trim() === '') {
          // Toast('Incomplete information')
          return;
        }
      }
      if (this.fileList.length === 0 && this.message.trim() === '') {
        // Toast('Incomplete information')
        return;
      }
      var arr1 = [];
      this.selectTopicList.forEach(function (item) {
        arr1.push(item.topicId);
      });
      var arr = [];
      this.fileList.forEach(function (item) {
        arr.push(item.id);
      });
      // const params = { categoryId: 1, 'content[indexes][101][body][imageIds]': arr, 'content[indexes][101][tomId]': 101, 'content[text]': this.message }
      var params = {
        topic_ids: arr1,
        categoryId: this.value1,
        title: this.title,
        content: {
          text: this.message,
          indexes: {
            101: {
              tomId: 101,
              body: {
                imageIds: arr
              }
            }
          }
        }
      };
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      post(params).then(function (res) {
        if (res.Code === 0) {
          _this9.$router.back();
        } else {
          console.log(res);
          _Toast(_this9.$t('postlater'));
        }
      });
      // Toast('调取发表接口')
    },
    back: function back() {
      var _this10 = this;
      var timer = setTimeout(function () {
        _this10.$router.back();
        clearTimeout(timer);
      }, 100);
    },
    beforeRead: function beforeRead(file) {
      // return new Promise((resolve) => {
      //   // compressorjs 默认开启 checkOrientation 选项
      //   // 会将图片修正为正确方向
      //   new Compressor(file, {
      //     quality: 0.6, // 压缩质量 可以查看文档获取明细
      //     success: resolve,
      //     error(err) {
      //       console.log(err.message)
      //     }
      //   })
      // })
      if (file.length > 9) {
        _Toast(this.$t('MaxPioture'));
        return false;
      }
      return true;
    }
  }
};